export const LocalStorageValues = {
    DELETE_MODAL: 'deleteModal',
    CANCEL_MODAL: 'cancelModal',
    REMOVE_SELECTION_MODAL: 'removeSelectionModal',
    TEMPORARY_SELECTION_MODAL: 'temporarySelectionModal',
    LOCAL_STORAGE_SID_KEY: 'sid',
    APPLYING_FILTERS_MODAL: 'applyingFiltersModal',
};
